'use client';
import { css, styled } from '@mui/material/styles';
import { excludeComponentProps } from '../utils/excludeComponentProps';
export const MenuList = styled('ul', excludeComponentProps('hasDivider'))(({ theme, hasDivider }) => css `
    --menu-list-min-width: 10rem;
    --menu-list-max-width: 18.75rem;

    margin: unset;
    padding: ${theme.tokens.FuelSpacing2} 0;

    min-width: var(--menu-list-min-width);
    max-width: var(--menu-list-max-width);
    background-color: ${theme.tokens.FuelColorWhite};
    flex: none;
    z-index: 2;

    ${hasDivider && css `
        .MenuItem-link.Dropdown-menuItem {
            border-bottom: 0.50px ${theme.tokens.FuelColorBorderBase} solid;
        };
        .MenuItem-root:not(:nth-last-of-type(1)) {
            border-bottom: solid 1px ${theme.tokens.FuelColorGray300};
        }
    `};
`);
